export default __webpack_public_path__ + "static/media/blisteringwounds.4e7e8bd8.png";